/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Terms_Of_ServiceInputs */

const en_mobile_terms_of_service = /** @type {(inputs: Mobile_Terms_Of_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Service`)
};

const es_mobile_terms_of_service = /** @type {(inputs: Mobile_Terms_Of_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Términos de Servicio`)
};

/**
* | output |
* | --- |
* | "Terms of Service" |
*
* @param {Mobile_Terms_Of_ServiceInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_terms_of_service = /** @type {((inputs?: Mobile_Terms_Of_ServiceInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Terms_Of_ServiceInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_terms_of_service(inputs)
	return en_mobile_terms_of_service(inputs)
});